import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersCompanyFeatureFlagsIndexResponseType } from "~/domains";

const request =
  async (): Promise<ApiMembersCompanyFeatureFlagsIndexResponseType> => {
    const response =
      await new ApiClient().get<ApiMembersCompanyFeatureFlagsIndexResponseType>(
        "/api/members/company_feature_flags",
      );
    return response.data;
  };

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersCompanyFeatureFlagsIndex = ({
  config = {},
}: PropsType = {}): UseQueryResult<ApiMembersCompanyFeatureFlagsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersCompanyFeatureFlagsIndex"],
    queryFn: () => request(),
  });
};
